<template lang="pug">
.v-credit-list.credit-list(v-if="data" :id="data?.id")
	.credit-list__tags.tags
		.tags__items(v-if="data.tabs")
			.tags__item(v-for="tab in data.tabs" @click="handlerTabClick(tab)" :class="{'active': tab.active}") {{tab.title}}
	.credit-list__filter(v-if="data.fields")
		.credit-list__fields
			v-filter(:filter="{...data, fields: data.fields, remote: data.remote, page, title: data.filterText}" :static-view="true" :action="formAction" @filter-updated="handlerFilterUpdated")
		.credit-list__filter-clear
			button.filter-clear-btn(type="button" @click="handlerClearFilter")
				v-svg-icon.filter-clear-btn__icon(icon="graphic-trash")
				span.filter-clear-btn__note(v-if="data.buttons?.clear?.text") {{data.buttons.clear.text}}
	.credit-list__items(v-if="data.items")
		.credit-list__item(v-for="item in data.items" :style="{'backgroundColor': item.backgroundColor}" :class="[item.theme ? 'credit-list__item--' + item.theme : '']")
			.credit-list__item-head
				h3.credit-list__item-title(v-if="item.title" v-html="item.title")
				.credit-list__item-text(v-if="item.text" v-html="item.text")
			.credit-list__item-features(v-if="item.features")
				.credit-list__item-feature(v-for="feature in item.features")
					.credit-list__item-feature-title(v-if="feature.title")
						| {{feature.title}}
						span.credit-list__item-feature-info(v-if="feature.info")
							v-informer(:info="feature.info")
					.credit-list__item-feature-text(v-if="feature.text") {{feature.text}}
			.credit-list__item-tags(v-if="item.tags")
				.credit-list__item-tag(v-for="tag in item.tags" :class="[tag.type ? 'credit-list__item-tag--' + tag.type : '']")
					v-svg-icon.credit-list__item-tag-icon(:icon="tag.type === 'negative' ? 'cross-sm' : 'tag-tick'")
					| {{tag.text}}
			.credit-list__item-banner(v-if="item.image" :style="{'backgroundColor': isTablet ? item.backgroundColor : ''}")
				img.credit-list__item-image(:src="item.image.src" :alt="item.image.alt")
			a.cover-link(v-if="item.link" :href="item.link") {{item.title}}
			.credit-list__item-actions(v-if="item.actions")
				v-action.credit-list__item-action.btn(v-for="action in item.actions" :action="action")
	.credit-list__action(v-if="!lastPage")
		button.btn.btn--stroke.credit-list__action-btn(type="button" @click="navigate") {{data.navigateText}}
			v-svg-icon.btn__arrow(icon="select-arrow")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			active: null,
			loading: false,
			page: null,
			formAction: null
		}
	},

	computed: {
		lastPage() {
			return Math.ceil(this.page.count / this.page.limit) ===  Math.ceil(this.page.offset / this.page.limit) + 1;
		}
	},

	methods: {
		dataSet(data, options = {}) {
			this.page = data.page;
			if (options.append) {
				this.data.items = [...this.data.items, ...data.items];
				return;
			}
			if(data.tabs?.length) {
				this.active = data.tabs?.find(item => item.active) || data?.tabs[0];
			}
			this.data = data;
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: {
					id: dataSetOptions.id,
					page: dataSetOptions.page || this.page
				},
			}, dataSetOptions);
		},

		handlerTabClick(item) {
			this.requestDataLoad({id: item.id, updateUrl: true, page: {...this.page, offset: 0}});
		},

		navigate() {
			this.requestDataLoad({append: true, page: {...this.page, offset: this.page.offset + this.page.limit}, id: this.active?.id, updateUrl: true});
		},

		handlerClearFilter() {
			this.formAction = 'clear';
			setTimeout(() => this.formAction = null, 0);
		},

		handlerFilterUpdated(res) {
			this.data = res;
			this.items = res.items;
			this.page = res.page;
			this.filterCount = res.filterCount;
		}
	}
}

</script>